<script setup>
  import { computed } from 'vue'

  const props = defineProps({
    item: Object
  })

  const urlLink = computed(() => {
    if (!props.item.link) return false
    return props.item.link
  })

  const categories = computed(() => {
    if (!props.item.categories) return []

    if (Array.isArray(props.item.categories)) {
      return props.item.categories
        .map((category) => category?.title ?? category?.props?.title)
        .filter(Boolean)
    }

    return props.item.categories
      .split(',')
      .map((category) => category.trim())
      .filter(Boolean)
  })

</script>

<template>
  <div
    class="step-list-content-item border-t last:border-b border-border first:mt-8 py-8"
  >
    <p
      class="step-list-content-item-headline font-semibold mb-2"
    >
      {{ item.headline }}
    </p>
    <div
      class="step-list-content-item-text"
      v-html="item.text"
    />
    <div
      v-if="categories.length"
      class="step-list-content-item-categories flex flex-wrap gap-4 mt-4"
    >
      <span
        v-for="category in categories"
        :key="category"
        class="flex flex-row w-fit items-center uppercase border text-headline border-body py-3 px-4 rounded-full ~text-xs/sm"
      >
        {{ category }}
      </span>
    </div>
    <div
      v-else-if="urlLink"
      class="step-list-content-item-link"
    >
      <div
        class="text-primary text-base flex flex-row items-center gap-4 mt-4"
      >
        <AppIcon
          name="ArrowLink"
        />
        <span
          class="underline underline-offset-4 ~text-sm/base"
          v-html="urlLink"
        >
        </span>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .step-list-content-item-link :deep(svg) {
    @apply h-4 w-4 transition-transform duration-300 ease-in-out;
  }

  .step-list-content-item-link:hover :deep(svg) {
    @apply translate-x-2;
  }

</style>
